<template>
  <div class="mobile">
    <div class="progress-bar-wrapper">
      <div class="progress-bar">
        <div id="progress"></div>
      </div>
      <div class="bg"></div>
    </div>
    <div class="mobile-header" :class="{ hidden: isScrollDown }">
      <a href="/" class="logo">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M23.3279 15.5408L35.1106 10.5296L35.171 10.669L23.3883 15.6803L23.3279 15.5408ZM22.6371 14.5268L32.6496 6.6507L32.4509 6.40986L22.4385 14.2859L22.6371 14.5268ZM21.6052 13.5887L29.066 3.35493L28.6774 3.08451L21.2166 13.3183L21.6052 13.5887ZM24.5541 1.05211L23.9539 0.84507L19.6839 12.7014L20.284 12.9085L24.5541 1.05211ZM19.6536 0.0464789L18.8635 0L18.0864 12.5493L18.8765 12.5958L19.6536 0.0464789ZM17.4733 12.6507L14.7964 0.350704L13.8638 0.54507L16.5363 12.8408L17.4689 12.6465L17.4733 12.6507ZM16.1262 13.0479L10.2456 1.86761L9.2569 2.3662L15.1374 13.5465L16.1262 13.0479ZM14.9216 13.7577L6.22164 4.50423L5.28472 5.34507L13.9846 14.5944L14.9216 13.7535V13.7577ZM13.9242 14.7592L2.97481 8.18028L2.22787 9.37183L13.1773 15.9465L13.9242 14.7549V14.7592ZM36 23.4465L24.2173 18.431L23.1379 20.8606L22.1708 22.0056L20.9403 22.8423L19.5284 23.3324L18.0389 23.4423L16.5277 23.1423L15.1331 22.4324L14.0365 21.4183L13.2636 20.1592L12.8664 18.7901H12.8578L12.8491 17.4085H12.8146L13.1988 16.0479L0.811705 12.7056L0.388582 14.2056L12.2706 17.4127L0 17.5014L0.0129527 19.2127L11.6445 19.1282L0.509475 22.2169L1.02758 24.0127L11.6402 21.0718L2.23651 26.607L3.30295 28.3394L12.2749 23.0535L5.1077 30.4521L6.72248 31.9521L13.6867 24.7606L9.0367 33.4944L11.1523 34.5718L15.6685 26.0958L13.7429 35.4127L16.2384 35.907L17.987 27.4521L18.6433 36L21.3418 35.8014L20.7373 27.9254L23.4272 35.3155L26.1257 34.3732L23.6215 27.4944L27.8527 33.4437L30.3353 31.7535L26.3286 26.1211L31.6954 30.4563L33.7203 28.0521L28.4399 23.7887L34.6615 26.438L35.9957 23.438L36 23.4465Z"
              fill="black"/>
        </svg>
        Charla
      </a>
      <div class="header-buttons">
        <a :href="$t('charlaRegLink')" rel="nofollow noopener"  target="_blank" class="login-btn">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M31 28V29H29V28C29 26.35 27.65 25 26 25H14C12.35 25 11 26.35 11 28V29H9V28C9 25.24 11.24 23 14 23H26C28.76 23 31 25.24 31 28ZM15 16C15 13.24 17.24 11 20 11C22.76 11 25 13.24 25 16C25 18.76 22.76 21 20 21C17.24 21 15 18.76 15 16ZM17 16C17 17.65 18.35 19 20 19C21.65 19 23 17.65 23 16C23 14.35 21.65 13 20 13C18.35 13 17 14.35 17 16Z"
                fill="black"/>
          </svg>
        </a>
        <div class="menu-btn" @click="this.getNewMenuState('opened');">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="11" y="17" width="2" height="2" fill="white"/>
            <rect x="15" y="16" width="2" height="4" fill="white"/>
            <rect x="19" y="14" width="2" height="8" fill="white"/>
            <rect x="23" y="17" width="2" height="2" fill="white"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="mobile-main">
      <section class="screen" id="screen1">
        <div class="title-side">
          <h1>{{ $t("CharlaLandingBlock.title_part1") }}<br>
            <span><img src="@/components/mobile/mobile/img/title-orange.svg" alt="">{{ $t("CharlaLandingBlock.title_part2") }}</span>
            {{ $t("CharlaLandingBlock.title_part3") }} <strong>Charla</strong>
          </h1>
          <h3 v-html='$t("CharlaLandingBlock.slogan")'></h3>
          <a :href="$t('charlaRegLink')" rel="nofollow noopener"  target="_blank" class="screen-start-btn">
            <div class="btn-text">{{ $t("footer.btn") }}</div>
            <div class="plus">
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0H8V6H0V8H8V14H10V8H18V6H10V0Z" fill="black"/>
              </svg>
            </div>
          </a>
          <p>{{ $t("CharlaLandingBlock.info1") }}</p>
        </div>
        <div class="content-side">
          <div class="screen1-slider">
            <swiper
                :slidesPerView="2.05"
                :centeredSlides="true"
                :modules="modules"
                class="swiper1"
            >
              <swiper-slide>
                <div class="screen1-slide">
                  <div class="number">100+</div>
                  <div class="title" v-html='$t("CharlaLandingBlock.slider.carouselItem1.title")'></div>
                  <div class="text" v-html='$t("CharlaLandingBlock.slider.carouselItem1.text")'></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screen1-slide">
                  <div class="number">93%</div>
                  <div class="title" v-html='$t("CharlaLandingBlock.slider.carouselItem2.title")'></div>
                  <div class="text" v-html='$t("CharlaLandingBlock.slider.carouselItem2.text")'></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screen1-slide">
                  <div class="number">x46</div>
                  <div class="title" v-html='$t("CharlaLandingBlock.slider.carouselItem3.title")'></div>
                  <div class="text" v-html='$t("CharlaLandingBlock.slider.carouselItem3.text")'></div>
                </div>
              </swiper-slide>
<!--              <swiper-slide>-->
<!--                <div class="screen1-slide">-->
<!--                  <div class="number">100%</div>-->
<!--                  <div class="title" v-html='$t("CharlaLandingBlock.slider.carouselItem4.title")'></div>-->
<!--                  <div class="text" v-html='$t("CharlaLandingBlock.slider.carouselItem4.text")'></div>-->
<!--                </div>-->
<!--              </swiper-slide>-->
            </swiper>
          </div>
          <div class="video-mobile-wrapper">
            <video src="@/components/mobile/mobile/background-video.mp4"
                   poster="@/components/mobile/mobile/img/video-poster.png" autoplay muted playsinline
                   loop></video>
          </div>
        </div>
        <div @click="scrollToSecondScreen" class="next-btn">{{$t("footer.screen_name1")}}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.42 16H6.58L0 9.42L1.42 8L7 13.58L7 0L9 8.74224e-08V13.58L14.58 8L16 9.42L9.42 16Z"
                  fill="black"/>
          </svg>
        </div>
      </section>
      <section class="screen" id="screen2" ref="secondScreen">
        <div class="title-side">
          <div class="h2">
            {{ $t("CharlaHowItWork.title_part1") }}<br>
            <strong>Charla</strong>{{ $t("CharlaHowItWork.title_part2") }}<br>
            <img src="@/components/mobile/mobile/img/title-green.svg" alt="">
          </div>
          <h3>{{ $t("CharlaHowItWork.slogan_part1") }} <span>⟶</span> {{ $t("CharlaHowItWork.slogan_part2") }}</h3>
          <p v-html='$t("CharlaHowItWork.info")'></p>
        </div>
        <div class="content-side">
          <div class="screen2-slider">
            <swiper
                :slidesPerView="1.3"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton2, nextEl: nextButton2 }"
                :pagination="{el: pagination2, clickable: true}"
                :modules="modules"
                class="swiper2"
            >
              <swiper-slide>
                <div class="img-slide-wrapper">
                  <div class="img-slide-title">{{$t("CharlaHowItWork.slide1")}}</div>
                  <img  v-if="Tr.currentLocale !=='ru'" src="@/assets/img/HowItWorkScreen1.webp" alt="">
                  <img  v-if="Tr.currentLocale === 'ru'" src="@/assets/img/HowItWorkScreen1_ru.webp" alt="">
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="img-slide-wrapper">
                  <div class="img-slide-title">{{$t("CharlaHowItWork.slide2")}}</div>
                  <img  v-if="Tr.currentLocale !=='ru'" src="@/assets/img/HowItWorkScreen3.webp" alt="">
                  <img  v-if="Tr.currentLocale === 'ru'" src="@/assets/img/HowItWorkScreen3_ru.webp" alt="">
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="img-slide-wrapper">
                  <div class="img-slide-title">{{$t("CharlaHowItWork.slide3")}}</div>
                  <img  v-if="Tr.currentLocale !=='ru'" src="@/assets/img/HowItWorkScreen2.webp" alt="">
                  <img  v-if="Tr.currentLocale === 'ru'" src="@/assets/img/HowItWorkScreen2_ru.webp" alt="">
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider2-prev slider-button-prev swiper-button-prev" ref="prevButton2">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider2-pag" ref="pagination2"></div>
            <div class="slider2-next slider-button-next swiper-button-next" ref="nextButton2">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <a :href="$t('charlaRegLink')" rel="nofollow noopener"  target="_blank" class="join-btn">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0H8V6H0V8H8V14H10V8H18V6H10V0Z" fill="white"/>
          </svg>
          {{ $t("footer.btn") }}</a>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen3">
        <div class="title-side">
          <div class="h2">
            {{ $t("CharlaCompare.title_part1") }}<br>
            <strong>Charla</strong> {{ $t("CharlaCompare.title_part2") }}<br>
            <img src="@/components/mobile/mobile/img/title-purple.svg" alt="">

          </div>
          <p>{{ $t("CharlaCompare.slogan") }}</p>
        </div>
        <div class="content-side">
          <div class="tumbs">
            <div class="tumb audioTumb" id="phoneTalk"
                 :class="{ 'active-tumb': activeButton === 'phoneTalk' }"
                 @click="onPhoneTalkClick"

            >{{ $t("CharlaCompare.choose_item1") }}</div>
            <div class="tumb audioTumb" id="Literary"
                 :class="{ 'active-tumb': activeButton === 'literary' }"
                 @click="onLiteraryClick"
            >{{ $t("CharlaCompare.choose_item2") }}</div>
          </div>
          <div class="mobile-audio-wave">
            <audioWaveMobile :file="audioSrc" ref="audioWaveMobile"></audioWaveMobile>
          </div>
<!--          <div class="spectrograph">-->
<!--            <div class="audio-play-btn" @click="playPauseAudio" :class="{ 'audio-pause': audioIsPaused }">-->
<!--              <div class="pause-mobile-icon">-->
<!--                <span></span><span></span>-->
<!--              </div>-->
<!--              <div class="play-mobile-icon">-->
<!--                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path d="M14 7L4 14V0L14 7Z" fill="#B561F7"/>-->
<!--                </svg>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div id="waveform"></div>-->
<!--          </div>-->
          <div class="comment charla-result">
            <div class="comment-header">
              <div class="comment-name">Charla</div>
              <div class="comment-rating">
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M6.54017 0.563829C6.94736 -0.187943 8.05264 -0.187943 8.45983 0.563829L10.023 3.44996C10.1801 3.73987 10.4663 3.94242 10.7978 3.99831L14.0987 4.55466C14.9585 4.69957 15.3001 5.72355 14.6919 6.33308L12.3572 8.67316C12.1226 8.90822 12.0133 9.23596 12.0612 9.56041L12.5381 12.7904C12.6623 13.6317 11.7681 14.2646 10.985 13.8895L7.97885 12.4496C7.67688 12.305 7.32312 12.305 7.02114 12.4496L4.01496 13.8895C3.23192 14.2646 2.33772 13.6317 2.46193 12.7904L2.93878 9.56041C2.98668 9.23596 2.87736 8.90822 2.64283 8.67316L0.308058 6.33308C-0.300098 5.72355 0.0414538 4.69957 0.901263 4.55466L4.20216 3.99831C4.53373 3.94242 4.81993 3.73987 4.97696 3.44996L6.54017 0.563829Z"
                      fill="white"/>
                </svg>
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M6.54017 0.563829C6.94736 -0.187943 8.05264 -0.187943 8.45983 0.563829L10.023 3.44996C10.1801 3.73987 10.4663 3.94242 10.7978 3.99831L14.0987 4.55466C14.9585 4.69957 15.3001 5.72355 14.6919 6.33308L12.3572 8.67316C12.1226 8.90822 12.0133 9.23596 12.0612 9.56041L12.5381 12.7904C12.6623 13.6317 11.7681 14.2646 10.985 13.8895L7.97885 12.4496C7.67688 12.305 7.32312 12.305 7.02114 12.4496L4.01496 13.8895C3.23192 14.2646 2.33772 13.6317 2.46193 12.7904L2.93878 9.56041C2.98668 9.23596 2.87736 8.90822 2.64283 8.67316L0.308058 6.33308C-0.300098 5.72355 0.0414538 4.69957 0.901263 4.55466L4.20216 3.99831C4.53373 3.94242 4.81993 3.73987 4.97696 3.44996L6.54017 0.563829Z"
                      fill="white"/>
                </svg>
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M6.54017 0.563829C6.94736 -0.187943 8.05264 -0.187943 8.45983 0.563829L10.023 3.44996C10.1801 3.73987 10.4663 3.94242 10.7978 3.99831L14.0987 4.55466C14.9585 4.69957 15.3001 5.72355 14.6919 6.33308L12.3572 8.67316C12.1226 8.90822 12.0133 9.23596 12.0612 9.56041L12.5381 12.7904C12.6623 13.6317 11.7681 14.2646 10.985 13.8895L7.97885 12.4496C7.67688 12.305 7.32312 12.305 7.02114 12.4496L4.01496 13.8895C3.23192 14.2646 2.33772 13.6317 2.46193 12.7904L2.93878 9.56041C2.98668 9.23596 2.87736 8.90822 2.64283 8.67316L0.308058 6.33308C-0.300098 5.72355 0.0414538 4.69957 0.901263 4.55466L4.20216 3.99831C4.53373 3.94242 4.81993 3.73987 4.97696 3.44996L6.54017 0.563829Z"
                      fill="white"/>
                </svg>
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M6.54017 0.563829C6.94736 -0.187943 8.05264 -0.187943 8.45983 0.563829L10.023 3.44996C10.1801 3.73987 10.4663 3.94242 10.7978 3.99831L14.0987 4.55466C14.9585 4.69957 15.3001 5.72355 14.6919 6.33308L12.3572 8.67316C12.1226 8.90822 12.0133 9.23596 12.0612 9.56041L12.5381 12.7904C12.6623 13.6317 11.7681 14.2646 10.985 13.8895L7.97885 12.4496C7.67688 12.305 7.32312 12.305 7.02114 12.4496L4.01496 13.8895C3.23192 14.2646 2.33772 13.6317 2.46193 12.7904L2.93878 9.56041C2.98668 9.23596 2.87736 8.90822 2.64283 8.67316L0.308058 6.33308C-0.300098 5.72355 0.0414538 4.69957 0.901263 4.55466L4.20216 3.99831C4.53373 3.94242 4.81993 3.73987 4.97696 3.44996L6.54017 0.563829Z"
                      fill="white"/>
                </svg>
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M6.54017 0.563829C6.94736 -0.187943 8.05264 -0.187943 8.45983 0.563829L10.023 3.44996C10.1801 3.73987 10.4663 3.94242 10.7978 3.99831L14.0987 4.55466C14.9585 4.69957 15.3001 5.72355 14.6919 6.33308L12.3572 8.67316C12.1226 8.90822 12.0133 9.23596 12.0612 9.56041L12.5381 12.7904C12.6623 13.6317 11.7681 14.2646 10.985 13.8895L7.97885 12.4496C7.67688 12.305 7.32312 12.305 7.02114 12.4496L4.01496 13.8895C3.23192 14.2646 2.33772 13.6317 2.46193 12.7904L2.93878 9.56041C2.98668 9.23596 2.87736 8.90822 2.64283 8.67316L0.308058 6.33308C-0.300098 5.72355 0.0414538 4.69957 0.901263 4.55466L4.20216 3.99831C4.53373 3.94242 4.81993 3.73987 4.97696 3.44996L6.54017 0.563829Z"
                      fill="white"/>
                </svg>
              </div>
            </div>
            <div class="comment-text" id="charlaResult" v-html='itemsComp[0].response[0]'></div>
            <div class="comment-text-wrapper">
              <div class="comment-text-container">
                <p class="comment-text" v-html='itemsComp[0].response[1]'>
                </p>
              </div>
            </div>
            <button class="comment-button" @click="openAllCards()">{{showButton}}</button>
            <div class="comment-clip">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.19209e-06 0H20C8.9543 -4.82823e-07 4.82818e-07 8.95441 0 20L1.19209e-06 0Z"
                      fill="#98DA2C"/>
              </svg>
            </div>
          </div>
          <div class="screen3-slider">
            <swiper
                :slidesPerView="1.3"
                :spaceBetween="8"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton3, nextEl: nextButton3 }"
                :pagination="{el: pagination3, clickable: true}"
                :modules="modules"
                class="swiper3"
            >
              <swiper-slide>
                <div class="comment">
                  <div class="comment-header">
                    <div class="comment-name">{{ $t("CharlaCompare.slider.appResponse.title") }}</div>
                  </div>
                  <div class="comment-text" id="appResult" v-html='itemsComp[1].response[0]'></div>
                  <div class="comment-text-wrapper">
                    <div class="comment-text-container">
                      <p class="comment-text" v-html='itemsComp[1].response[1]'>
                      </p>
                    </div>
                  </div>
                  <button class="comment-button" @click="openAllCards()">{{showButton}}</button>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="comment">
                  <div class="comment-header">
                    <div class="comment-name">{{ $t("CharlaCompare.slider.messengerResponse.title") }}</div>
                  </div>
                  <div class="comment-text" id="messengerResult" v-html='itemsComp[2].response[0]'></div>
                  <div class="comment-text-wrapper">
                    <div class="comment-text-container">
                      <p class="comment-text" v-html='itemsComp[2].response[1]'>
                      </p>
                    </div>
                  </div>
                  <button class="comment-button" @click="openAllCards()">{{showButton}}</button>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="comment">
                  <div class="comment-header">
                    <div class="comment-name">{{ $t("CharlaCompare.slider.searchResponse.title") }}</div>

                  </div>
                  <div class="comment-text" id="searchResult" v-html='itemsComp[3].response[0]'></div>
                  <div class="comment-text-wrapper">
                    <div class="comment-text-container">
                      <p class="comment-text" v-html='itemsComp[3].response[1]'>
                      </p>
                    </div>
                  </div>
                  <button class="comment-button" @click="openAllCards()">{{showButton}}</button>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider3-prev slider-button-prev swiper-button-prev" ref="prevButton3">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider3-pag" ref="pagination3"></div>
            <div class="slider3-next slider-button-next swiper-button-next" ref="nextButton3">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen4">
        <div class="title-side">
          <div class="h2">
            <span v-html="$t('charlaMoney.title_part1')"></span><br>
            <span v-html="$t('charlaMoney.title_part2')"></span><br>
            {{$t("charlaMoney.title_part3")}}<br>
            <img src="@/components/mobile/mobile/img/title-orange2.svg" alt="">
          </div>
          <p>{{ $t("charlaMoney.slogan") }}</p>
        </div>
        <div class="content-side">
          <div class="tumbs">
            <div class="tumb sliderTumb"
                 :class="{ 'active-tumb': activeItem === 'Business Areas' }"
                 @click="selectItems('Business Areas')">
              {{ $t("charlaMoney.choose_item1") }}</div>
            <div class="tumb sliderTumb"
                 :class="{ 'active-tumb': activeItem === 'Objectives' }"
                 @click="selectItems('Objectives')">
              {{ $t("charlaMoney.choose_item2") }}</div>
          </div><br>
          <div class="screen4-slider">
            <swiper
                :slidesPerView="1.5"
                :spaceBetween="8"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton4, nextEl: nextButton4 }"
                :pagination="{el: pagination4, clickable: true}"
                :modules="modules"
                class="swiper4"
            >
              <swiper-slide>
                <div class="slide-double-card">
                  <div class="card card--1">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[0].itemTitle'></div>
                      <div class="card-num">— 01</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[0].itemText'></div>
                  </div>
                  <div class="card card--2">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[1].itemTitle'></div>
                      <div class="card-num">— 02</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[1].itemText'></div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slide-double-card">
                  <div class="card card--3">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[2].itemTitle'></div>
                      <div class="card-num">— 03</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[2].itemText'></div>
                  </div>
                  <div class="card card--4">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[3].itemTitle'></div>
                      <div class="card-num">— 04</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[3].itemText'></div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slide-double-card">
                  <div class="card card--5">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[4].itemTitle'></div>
                      <div class="card-num">— 05</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[4].itemText'></div>
                  </div>
                  <div class="card card--6">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[5].itemTitle'></div>
                      <div class="card-num">— 06</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[5].itemText'></div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide v-if="!longSlides">
                <div class="slide-double-card">
                  <div class="card card--7">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[6].itemTitle'></div>
                      <div class="card-num">— 07</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[6].itemText'></div>
                  </div>
                  <div class="card card--8">
                    <div class="card-header">
                      <div class="card-title" v-html='SliderItems[7].itemTitle'></div>
                      <div class="card-num">— 08</div>
                    </div>
                    <div class="card-text" v-html='SliderItems[7].itemText'></div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider4-prev slider-button-prev swiper-button-prev" ref="prevButton4">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider4-pag" ref="pagination4"></div>
            <div class="slider4-next slider-button-next swiper-button-next" ref="nextButton4">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <a :href="$t('charlaRegLink')" rel="nofollow noopener"  target="_blank" class="join-btn">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0H8V6H0V8H8V14H10V8H18V6H10V0Z" fill="white"/>
          </svg>
          {{ $t("footer.btn") }}</a>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen5">
        <div class="title-side">
          <div class="h2">
            {{ $t("CharlaStatistics.title_part1") }}<br>
            <span v-html='$t("CharlaStatistics.title_part2")'></span><br>
            <img src="@/components/mobile/mobile/img/title-orange3.svg" alt="">
          </div>
          <p>{{ $t("CharlaStatistics.slogan") }}</p>
          <h3>{{ $t("CharlaStatistics.info") }} <span>⟶</span></h3>
        </div>
        <div class="content-side">
          <div class="screen5-slider">
            <swiper
                :slidesPerView="1.5"
                :spaceBetween="8"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton5, nextEl: nextButton5 }"
                :pagination="{el: pagination5, clickable: true}"
                :modules="modules"
                class="swiper5"
            >
              <swiper-slide>
                <div class="slider5-slide slide5--1">
                  <div class="slide5-header">
                    <div class="title">{{ $t("CharlaStatistics.slider.carouselItem1.title") }}</div>
                    <div class="num">x46</div>
                    <div class="text">{{ $t("CharlaStatistics.slider.carouselItem1.numbers") }}</div>
                  </div>
                  <div class="vs-block">
                    <div class="vs1">
                      <div class="name">Charla:</div>
                      <div class="desk" v-html='$t("CharlaStatistics.slider.carouselItem1.vs_charla")'></div>
                    </div>
                    <div class="vs">{{ $t("CharlaStatistics.slider.carouselItem1.vs") }}</div>
                    <div class="vs2">
                      <div class="name">{{ $t("CharlaStatistics.slider.carouselItem1.sub_title") }}</div>
                      <div class="desk" v-html='$t("CharlaStatistics.slider.carouselItem1.vs_charla")'>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider5-slide slide5--2">
                  <div class="slide5-header">
                    <div class="title">{{ $t("CharlaStatistics.slider.carouselItem2.title") }}</div>
                    <div class="num">100%</div>
                    <div class="text">{{ $t("CharlaStatistics.slider.carouselItem2.numbers") }}</div>
                  </div>
                  <div class="text-slide5-block">
                    {{ $t("CharlaStatistics.slider.carouselItem2.text_part1") }}
                    <span>{{ $t("CharlaStatistics.slider.carouselItem2.text_part2") }}
                    </span> {{ $t("CharlaStatistics.slider.carouselItem2.text_part3") }}
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider5-slide slide5--3">
                  <div class="slide5-header">
                    <div class="title">{{ $t("CharlaStatistics.slider.carouselItem3.title") }}</div>
                    <div class="num">60%</div>
                    <div class="text">{{ $t("CharlaStatistics.slider.carouselItem3.numbers") }}</div>
                  </div>
                  <div class="text-slide5-block">
                    <span>{{ $t("CharlaStatistics.slider.carouselItem3.text_part1") }}</span>
                    {{ $t("CharlaStatistics.slider.carouselItem3.text_part2") }}
                    <span>{{ $t("CharlaStatistics.slider.carouselItem3.text_part3") }}</span> {{ $t("CharlaStatistics.slider.carouselItem3.text_part4") }}
                    <span>{{ $t("CharlaStatistics.slider.carouselItem3.text_part5") }}</span> {{ $t("CharlaStatistics.slider.carouselItem3.text_part6") }}
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider5-slide slide5--4">
                  <div class="slide5-header">
                    <div class="title">{{ $t("CharlaStatistics.slider.carouselItem4.title") }}</div>
                    <div class="vs-block">
                      <div>
                        <div class="num">100+</div>
                        <div class="text">{{ $t("CharlaStatistics.slider.carouselItem4.numbers") }}</div>
                      </div>
                      <div>
                        <div class="num">1M+</div>
                        <div class="text">{{ $t("CharlaStatistics.slider.carouselItem4.text_part1") }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="text-slide5-block">
                    <div class="name">Charla:</div>
                    {{ $t("CharlaStatistics.slider.carouselItem4.text_part2") }}
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider5-prev slider-button-prev swiper-button-prev" ref="prevButton5">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider5-pag" ref="pagination5"></div>
            <div class="slider5-next slider-button-next swiper-button-next" ref="nextButton5">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen6">
        <div class="title-side">
          <div class="h2">
            <strong>{{ $t("CharlaApplications.title_part1") }}</strong><br>
            {{ $t("CharlaApplications.title_part2") }}<br>
            {{ $t("CharlaApplications.title_part3") }}<br>
            <img src="@/components/mobile/mobile/img/title-purple2.svg" alt="">
          </div>
          <p>{{ $t("CharlaApplications.slogan") }}</p>
          <h3>{{ $t("CharlaApplications.info") }} </h3>
        </div>
        <div class="content-side">
          <div class="screen6-slider">
            <swiper
                :slidesPerView="1.5"
                :spaceBetween="8"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton6, nextEl: nextButton6 }"
                :pagination="{el: pagination6, clickable: true}"
                :modules="modules"
                class="swiper6"
            >
              <swiper-slide>
                <div class="screen6-slide slide6--1">
                  <div>
                    <div class="slide-header">
                      <span>Charla</span><br>
                      {{ $t("CharlaApplications.slider.carouselItem1.title") }}
                    </div>
                    <div class="slide-body">{{ $t("CharlaApplications.slider.carouselItem1.text_part1") }}
                    </div>
                  </div>
                  <div class="slide-footer">
                    {{ $t("CharlaApplications.slider.carouselItem1.text_part2") }}
                    <div @click="setFormState(true)" class="btn">{{ $t("CharlaApplications.slider.carouselItem1.btn") }}</div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screen6-slide slide6--2">
                  <div>
                    <div class="slide-header">
                      <span>{{ $t("CharlaApplications.slider.carouselItem2.title_part1") }}</span><br>
                      {{ $t("CharlaApplications.slider.carouselItem2.title_part2") }}
                    </div>
                    <div class="slide-body">{{ $t("CharlaApplications.slider.carouselItem2.text_part1") }}</div>
                  </div>
                  <div class="slide-footer">
                    {{ $t("CharlaApplications.slider.carouselItem2.text_part2") }}
                    <a :href="$t('charlaRegLink')" rel="nofollow noopener"  target="_blank" class="btn">{{ $t("CharlaApplications.slider.carouselItem2.btn") }}</a>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screen6-slide slide6--3">
                  <div>
                    <div class="slide-header">
                      <span>Telegram</span><br>
                      {{ $t("CharlaApplications.slider.carouselItem3.title") }}
                    </div>
                    <div class="slide-body">{{ $t("CharlaApplications.slider.carouselItem3.text_part1") }}</div>
                  </div>
                  <div class="slide-footer">
                    {{ $t("CharlaApplications.slider.carouselItem3.text_part2") }}
                    <a :href="$t('charlaTg')" target="_blank" class="btn">{{ $t("CharlaApplications.slider.carouselItem3.btn") }}</a>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider6-prev slider-button-prev swiper-button-prev" ref="prevButton6">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider6-pag" ref="pagination6"></div>
            <div class="slider6-next slider-button-next swiper-button-next" ref="nextButton6">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen7">
        <div class="title-side">
          <div class="h2">
            {{ $t("CharlaReview.title_part1") }}<br>
            <div v-html='$t("CharlaReview.title_part2")'></div><br>
            <img src="@/components/mobile/mobile/img/title-green2.svg" alt="">
          </div>
          <p>{{ $t("CharlaReview.slogan") }}</p>
          <div class="features">
            <div>
              <div class="num">250K</div>
              <div class="text" v-html='$t("CharlaReview.info_part1")'></div>
            </div>
            <div>
              <div class="num">3M+</div>
              <div class="text" v-html='$t("CharlaReview.info_part2")'></div>
            </div>
          </div>
        </div>
        <div class="content-side">
          <div class="screen7-slider">
            <swiper
                :slidesPerView="1.5"
                :spaceBetween="8"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton7, nextEl: nextButton7 }"
                :pagination="{el: pagination7, clickable: true}"
                :modules="modules"
                class="swiper7"
            >
              <swiper-slide>
                <div class="slider7-slide">
                  <svg class="slider7-clip" width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 1.58946e-06L0 0C11.0457 4.82823e-07 20 8.95441 20 20L20 1.58946e-06Z"
                          fill="#F6F5F8"/>
                  </svg>
                  <div class="slide-header">
                    <div class="name" v-html='$t("CharlaReview.reviews.review1.name")'></div>
                    <div class="date">{{$t("CharlaReview.reviews.review1.date")}}</div>
                  </div>
                  <div class="slide-body">{{$t("CharlaReview.reviews.review1.text")}}</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider7-slide">
                  <svg class="slider7-clip" width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 1.58946e-06L0 0C11.0457 4.82823e-07 20 8.95441 20 20L20 1.58946e-06Z"
                          fill="#F6F5F8"/>
                  </svg>
                  <div class="slide-header">
                    <div class="name" v-html='$t("CharlaReview.reviews.review2.name")'></div>
                    <div class="date">{{$t("CharlaReview.reviews.review2.date")}}</div>
                  </div>
                  <div class="slide-body">{{$t("CharlaReview.reviews.review2.text")}}</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider7-slide">
                  <svg class="slider7-clip" width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 1.58946e-06L0 0C11.0457 4.82823e-07 20 8.95441 20 20L20 1.58946e-06Z"
                          fill="#F6F5F8"/>
                  </svg>
                  <div class="slide-header">
                    <div class="name" v-html='$t("CharlaReview.reviews.review3.name")'></div>
                    <div class="date">{{$t("CharlaReview.reviews.review3.date")}}</div>
                  </div>
                  <div class="slide-body">{{$t("CharlaReview.reviews.review3.text")}}</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider7-slide">
                  <svg class="slider7-clip" width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 1.58946e-06L0 0C11.0457 4.82823e-07 20 8.95441 20 20L20 1.58946e-06Z"
                          fill="#F6F5F8"/>
                  </svg>
                  <div class="slide-header">
                    <div class="name" v-html='$t("CharlaReview.reviews.review4.name")'></div>
                    <div class="date">{{$t("CharlaReview.reviews.review4.date")}}</div>
                  </div>
                  <div class="slide-body">{{$t("CharlaReview.reviews.review4.text")}}</div>
                </div>
              </swiper-slide>
<!--              <swiper-slide>-->
<!--                <router-link :to="Tr.i18nRoute({ name: 'reviews' })" class="slider7-slide slide7-link">-->
<!--                  <svg class="slider7-clip" width="20" height="20" viewBox="0 0 20 20" fill="none"-->
<!--                       xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path d="M20 1.58946e-06L0 0C11.0457 4.82823e-07 20 8.95441 20 20L20 1.58946e-06Z"-->
<!--                          fill="#98DA2C"/>-->
<!--                  </svg>-->
<!--                  <div class="slide-header">-->
<!--                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"-->
<!--                         xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path-->
<!--                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"-->
<!--                          fill="white"/>-->
<!--                    </svg>-->
<!--                  </div>-->
<!--                  <div class="slide-footer" v-html='$t("CharlaReview.more_btn")'></div>-->
<!--                </router-link>-->
<!--              </swiper-slide>-->
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider7-prev slider-button-prev swiper-button-prev" ref="prevButton7">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider7-pag" ref="pagination7"></div>
            <div class="slider7-next slider-button-next swiper-button-next" ref="nextButton7">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen8">
        <div class="title-side">
          <div class="h2">
            {{ $t("CharlaAdvantages.title_part1") }}<br>
            {{ $t("CharlaAdvantages.title_part2") }} <strong>Charla</strong><br>
            <img src="@/components/mobile/mobile/img/title-orange4.svg" alt="">
          </div>
          <p>{{ $t("CharlaAdvantages.slogan") }}</p>
          <h3>{{ $t("CharlaAdvantages.info") }} <span>’’_’’</span></h3>
        </div>
        <div class="content-side">
          <div class="screen8-slider">
            <swiper
                :slidesPerView="1.5"
                :spaceBetween="8"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton8, nextEl: nextButton8 }"
                :pagination="{el: pagination8, clickable: true}"
                :modules="modules"
                class="swiper8"
            >
              <swiper-slide>
                <div class="slider8-slide slide8--1">
                  <div>
                    <div class="slide-header">
                      <div class="title">{{ $t("CharlaAdvantages.slider.carouselItem1.title") }}</div>
                      <div class="num">— 01</div>
                    </div>
                    <div class="slide-body" v-html='$t("CharlaAdvantages.slider.carouselItem1.text-mobile")'></div>
                  </div>
                  <div @click="setLangState(true);" class="btn">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"
                          fill="white"/>
                    </svg>
                    {{ $t("CharlaAdvantages.slider.carouselItem1.btn") }}</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider8-slide slide8--2">
                  <div class="slide-header">
                    <div class="title">{{ $t("CharlaAdvantages.slider.carouselItem2.title") }}</div>
                    <div class="num">— 02</div>
                  </div>
                  <div class="slide-body" v-html='$t("CharlaAdvantages.slider.carouselItem2.text")'></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider8-slide slide8--3">
                  <div class="slide-header">
                    <div class="title">{{ $t("CharlaAdvantages.slider.carouselItem3.title") }}</div>
                    <div class="num">— 03</div>
                  </div>
                  <div class="slide-body">
                    {{ $t("CharlaAdvantages.slider.carouselItem3.text") }}
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider8-slide slide8--4">
                  <div class="slide-header">
                    <div class="title">{{ $t("CharlaAdvantages.slider.carouselItem4.title") }}</div>
                    <div class="num">— 04</div>
                  </div>
                  <div class="slide-body">
                    {{ $t("CharlaAdvantages.slider.carouselItem4.text") }}
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider8-slide slide8--5">
                  <div class="slide-header">
                    <div class="title">{{ $t("CharlaAdvantages.slider.carouselItem5.title") }}</div>
                    <div class="num">— 05</div>
                  </div>
                  <div class="slide-body">{{ $t("CharlaAdvantages.slider.carouselItem5.text") }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider8-prev slider-button-prev swiper-button-prev" ref="prevButton8">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider8-pag" ref="pagination8"></div>
            <div class="slider8-next slider-button-next swiper-button-next" ref="nextButton8">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <a :href="$t('charlaRegLink')" rel="nofollow noopener"  target="_blank" class="join-btn">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0H8V6H0V8H8V14H10V8H18V6H10V0Z" fill="white"/>
          </svg>
          {{ $t("footer.btn") }}</a>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen9">
        <div class="title-side">
          <div class="h2">
            {{ $t("CharlaPrice.title_part1") }}<br>
            <strong>{{ $t("CharlaPrice.title_part2") }}</strong>
          </div>
        </div>
        <div class="content-side">
          <div class="rate-block">
            <div class="rate-block-header">
              <div class="name">{{ $t("CharlaPrice.Rates.rate1.title") }}</div>
              <div class="price">
                <span v-html='$t("CharlaPrice.Rates.rate1.price")'> </span>{{ $t("CharlaPrice.Rates.rate1.time") }}
              </div>
            </div>
            <div class="special">{{ $t("CharlaPrice.Rates.rate2.spec_li") }}</div>
            <div class="rate-block-ul">
              <ul>
                <li>{{ $t("CharlaPrice.Rates.rate1.li1") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li2") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li3") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li4") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li5") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li6") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li7") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li8") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li9") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate1.li10") }}</li>
              </ul>
            </div>
            <a :href="$t('charlaAuthLink')" target="_blank" class="start-btn">
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0H8V6H0V8H8V14H10V8H18V6H10V0Z" fill="white"/>
              </svg>
              {{ $t("CharlaPrice.Rates.rate1.btn") }}
            </a>
          </div>
          <div class="rate-block">
            <div class="rate-block-header">
              <div class="name">{{ $t("CharlaPrice.Rates.rate2.title") }}</div>
              <div class="price">
                {{ $t("CharlaPrice.Rates.rate2.time") }}
              </div>
            </div>
            <div class="special">{{ $t("CharlaPrice.Rates.rate3.spec_li") }}</div>
            <div class="rate-block-ul">
              <ul>
                <li>{{ $t("CharlaPrice.Rates.rate2.li1") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate2.li2") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate2.li3") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate2.li4") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate2.li5") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate2.li6") }}</li>
              </ul>
            </div>
            <div @click="setFormState(true)" target="_blank" class="start-btn">
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0H8V6H0V8H8V14H10V8H18V6H10V0Z" fill="white"/>
              </svg>
              {{ $t("CharlaPrice.Rates.rate2.btn") }}
            </div>
          </div>
          <div class="rate-block">
            <div class="rate-block-header">
              <div class="name">{{ $t("CharlaPrice.Rates.rate3.title") }}</div>
              <div class="price">
                <span v-html='$t("CharlaPrice.Rates.rate3.price")'> </span> {{ $t("CharlaPrice.Rates.rate3.time") }}
              </div>
            </div>
            <div class="special">{{ $t("CharlaPrice.Rates.rate1.spec_li") }}</div>
            <div class="rate-block-ul">
              <ul>
                <li>{{ $t("CharlaPrice.Rates.rate3.li1") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li2") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li3") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li4") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li5") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li6") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li7") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li8") }}</li>
                <li>{{ $t("CharlaPrice.Rates.rate3.li9") }}</li>
              </ul>
            </div>
            <a :href="$t('charlaAuthLink')" target="_blank" class="start-btn">
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0H8V6H0V8H8V14H10V8H18V6H10V0Z" fill="white"/>
              </svg>
              {{ $t("CharlaPrice.Rates.rate3.btn") }}
            </a>
          </div>
        </div>
        <div class="divider"></div>
      </section>
      <section class="screen" id="screen10">
        <div class="title-side">
          <div class="h2">
            {{ $t("CharlaQA.title_part1") }}<br>
            <span v-html='$t("CharlaQA.title_part2")'></span><br>
            <img src="@/components/mobile/mobile/img/title-purple3.svg" alt="">
          </div>
          <p>{{ $t("CharlaQA.slogan") }}</p>
          <div class="screen-start-btn" style="margin-top: 16px" @click="setFormState(true)">
            <div class="btn-text" >{{ $t("CharlaQA.btn") }}</div>
            <div class="plus">
              <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 0H8C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16H14C18.42 16 22 12.42 22 8C22 3.58 18.42 0 14 0ZM14 14H8C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2H14C17.31 2 20 4.69 20 8C20 11.31 17.31 14 14 14ZM7 5H15V7H7V5ZM7 9H11V11H7V9Z"
                    fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="content-side">
          <div class="screen10-slider">
            <swiper
                :slidesPerView="1.5"
                :spaceBetween="8"
                :centeredSlides="true"
                :navigation="{ prevEl: prevButton10, nextEl: nextButton10 }"
                :pagination="{el: pagination10, clickable: true}"
                :modules="modules"
                class="swiper10"
            >
              <swiper-slide>
                <div class="slider10-slide">
                  <div class="slider10-card" @click="setFaqState(true); setFaqContent('faqPage.faq.qa1')">
                    <div class="title">{{ $t("CharlaQA.qa.qa1") }}</div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"
                          fill="black"/>
                    </svg>
                  </div>
                  <div class="slider10-card" @click="setFaqState(true); setFaqContent('faqPage.faq.qa2')">
                    <div class="title">{{ $t("CharlaQA.qa.qa2") }}</div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"
                          fill="black"/>
                    </svg>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider10-slide">
                  <div class="slider10-card" @click="setFaqState(true); setFaqContent('faqPage.faq.qa3')">
                    <div class="title">{{ $t("CharlaQA.qa.qa3") }}</div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"
                          fill="black"/>
                    </svg>
                  </div>
                  <div class="slider10-card" @click="setFaqState(true); setFaqContent('faqPage.faq.qa4')">
                    <div class="title">{{ $t("CharlaQA.qa.qa4") }}</div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"
                          fill="black"/>
                    </svg>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="slider10-slide">
                  <div class="slider10-card" @click="setFaqState(true); setFaqContent('faqPage.faq.qa5')">
                    <div class="title">{{ $t("CharlaQA.qa.qa5") }}</div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"
                          fill="black"/>
                    </svg>
                  </div>
                  <div class="slider10-card" @click="setFaqState(true); setFaqContent('faqPage.faq.qa6')">
                    <div class="title">{{ $t("CharlaQA.qa.qa6") }}</div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16 0H4C1.79 0 0 1.79 0 4V16C0 18.21 1.79 20 4 20H16C18.21 20 20 18.21 20 16V4C20 1.79 18.21 0 16 0ZM18 16C18 17.1 17.1 18 16 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V16ZM11 10V16C11 16.55 10.55 17 10 17H4C3.45 17 3 16.55 3 16V10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10Z"
                          fill="black"/>
                    </svg>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="slider-control">
            <div class="slider10-prev slider-button-prev swiper-button-prev" ref="prevButton10">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6.58V9.42L6.58 16L8 14.58L2.42 9H48V7L2.42 7L8 1.42L6.58 0L0 6.58Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="swiper-pagination slider10-pag" ref="pagination10"></div>
            <div class="slider10-next slider-button-next swiper-button-next" ref="nextButton10">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 6.58V9.42L41.42 16L40 14.58L45.58 9H8.74234e-08L0 7L45.58 7L40 1.42L41.42 0L48 6.58Z"
                      fill="black"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="divider"></div>
      </section>
    </div>
    <footer>
      <div class="footer-links">
        <a @click="setAboutState(true);">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 9.42L16 6.58L9.42 -2.87621e-07L8 1.42L13.58 7L-3.0598e-07 7L-3.93402e-07 9L13.58 9L8 14.58L9.42 16L16 9.42Z"
                fill="#B561F7"/>
          </svg>
          {{ $t("subPagesUI.link1") }}</a>
        <a @click="setPrivacyState(true);">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 9.42L16 6.58L9.42 -2.87621e-07L8 1.42L13.58 7L-3.0598e-07 7L-3.93402e-07 9L13.58 9L8 14.58L9.42 16L16 9.42Z"
                fill="#B561F7"/>
          </svg>
          {{ $t("subPagesUI.link2") }}</a>
        <a @click="setTermsState(true);">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 9.42L16 6.58L9.42 -2.87621e-07L8 1.42L13.58 7L-3.0598e-07 7L-3.93402e-07 9L13.58 9L8 14.58L9.42 16L16 9.42Z"
                fill="#B561F7"/>
          </svg>
          {{ $t("subPagesUI.link3") }}</a>
        <a @click="setWorkingPopup(true);">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 9.42L16 6.58L9.42 -2.87621e-07L8 1.42L13.58 7L-3.0598e-07 7L-3.93402e-07 9L13.58 9L8 14.58L9.42 16L16 9.42Z"
                fill="#B561F7"/>
          </svg>
          {{ $t("subPagesUI.link4") }}</a>
      </div>
      <div class="footer-social-buttons">
        <a :href="$t('charlaTg')" target="_blank">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.5387 0.159118L0.591584 5.87106C-0.0501582 6.13706 -0.267213 6.66974 0.436474 6.95883L4.52761 8.16645L14.4194 2.48816C14.9596 2.13169 15.5125 2.22674 15.0367 2.61889L6.54093 9.76377L6.27406 12.7875C6.52125 13.2543 6.97385 13.2565 7.26255 13.0245L9.61303 10.9587L13.6386 13.7586C14.5736 14.2727 15.0823 13.9409 15.2835 12.9986L17.9239 1.3857C18.198 0.22578 17.7305 -0.285295 16.5387 0.159118Z"
                fill="white"/>
          </svg>
        </a>
<!--        <a href="https://wa.me/79856108675" target="_blank">-->
<!--          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path-->
<!--                d="M9.00001 0C13.9707 0 18 4.0293 18 8.99999C18 13.9707 13.9707 18 9.00001 18C7.40951 18.0026 5.847 17.5816 4.47301 16.7805L0.00361266 18L1.22041 13.5288C0.418596 12.1544 -0.00264454 10.5912 1.24922e-05 8.99999C1.24922e-05 4.0293 4.02931 0 9.00001 0ZM5.93281 4.77L5.75281 4.7772C5.63628 4.78429 5.52239 4.81491 5.41801 4.8672C5.32038 4.92248 5.23126 4.9916 5.15341 5.0724C5.04541 5.1741 4.98421 5.2623 4.91851 5.3478C4.58562 5.78061 4.40638 6.31198 4.40911 6.858C4.41091 7.299 4.52611 7.72829 4.70611 8.12969C5.07421 8.94149 5.67991 9.80099 6.47911 10.5975C6.67171 10.7892 6.86071 10.9818 7.06411 11.1609C8.05716 12.0352 9.24053 12.6657 10.5201 13.0023L11.0313 13.0806C11.1978 13.0896 11.3643 13.077 11.5317 13.0689C11.7938 13.0554 12.0498 12.9844 12.2814 12.861C12.3993 12.8003 12.5143 12.7342 12.6261 12.663C12.6261 12.663 12.6648 12.6378 12.7386 12.582C12.8601 12.492 12.9348 12.4281 13.0356 12.3228C13.1103 12.2454 13.1751 12.1545 13.2246 12.051C13.2948 11.9043 13.365 11.6244 13.3938 11.3913C13.4154 11.2131 13.4091 11.1159 13.4064 11.0556C13.4028 10.9593 13.3227 10.8594 13.2354 10.8171L12.7116 10.5822C12.7116 10.5822 11.9286 10.2411 11.4498 10.0233C11.3997 10.0014 11.346 9.98891 11.2914 9.98639C11.2298 9.98007 11.1676 9.987 11.1089 10.0067C11.0503 10.0264 10.9965 10.0585 10.9512 10.1007C10.9467 10.0989 10.8864 10.1502 10.2357 10.9386C10.1984 10.9888 10.1469 11.0267 10.0879 11.0475C10.0289 11.0684 9.96509 11.0712 9.90451 11.0556C9.84588 11.0399 9.78843 11.02 9.7326 10.9962C9.62101 10.9494 9.58231 10.9314 9.50581 10.899C8.98927 10.6736 8.51103 10.369 8.08831 9.99629C7.97491 9.89729 7.86961 9.78929 7.76161 9.68489C7.40754 9.3458 7.09896 8.9622 6.84361 8.54369L6.79051 8.45819C6.75237 8.40074 6.72153 8.33877 6.69871 8.27369C6.66451 8.14139 6.75361 8.03519 6.75361 8.03519C6.75361 8.03519 6.97231 7.79579 7.07401 7.66619C7.17301 7.54019 7.25671 7.4178 7.31071 7.3305C7.41691 7.1595 7.45021 6.984 7.39441 6.8481C7.14241 6.2325 6.88141 5.6196 6.61321 5.0112C6.56011 4.8906 6.40261 4.8042 6.25951 4.7871C6.21091 4.7817 6.16231 4.7763 6.11371 4.7727C5.99284 4.76669 5.87173 4.76789 5.75101 4.7763L5.93191 4.7691L5.93281 4.77Z"-->
<!--                fill="white"/>-->
<!--          </svg>-->
<!--        </a>-->
      </div>
      <div class="copyright">© 2024. Charla</div>
    </footer>
  </div>
</template>

<script>
import { ref } from 'vue';
import { Navigation, Pagination } from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/vue';
// import WaveSurfer from "wavesurfer.js";
import {mapActions, mapGetters} from "vuex";
import Tr from '@/i18n/translation'
import audioWaveMobile from "@/components/mobile/audioWaveMobile.vue";

export default {
  name: "CharlaMobile",
  components: {
    audioWaveMobile,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      isScrollDown: false,
      showButton: "",
      previousScrollPosition: 0,
      activeButton: 'phoneTalk',
      audioIsPaused: false,
      activeItem: 'Business Areas',
      longSlides: false,
      audioMode: 'operator'
    };
  },
  setup() {
    const secondScreen = ref(null);
    const prevButton2 = ref(null);
    const nextButton2 = ref(null);
    const pagination2 = ref(null);
    const prevButton3 = ref(null);
    const nextButton3 = ref(null);
    const pagination3 = ref(null);

    const prevButton4 = ref(null);
    const nextButton4 = ref(null);
    const pagination4 = ref(null);

    const prevButton5 = ref(null);
    const nextButton5 = ref(null);
    const pagination5 = ref(null);

    const prevButton6 = ref(null);
    const nextButton6 = ref(null);
    const pagination6 = ref(null);

    const prevButton7 = ref(null);
    const nextButton7 = ref(null);
    const pagination7 = ref(null);

    const prevButton8 = ref(null);
    const nextButton8 = ref(null);
    const pagination8 = ref(null);

    const prevButton10 = ref(null);
    const nextButton10 = ref(null);
    const pagination10 = ref(null);
    const scrollToSecondScreen = () => {
      secondScreen.value.scrollIntoView({ behavior: 'smooth' });
    };
    return {
      modules: [Navigation, Pagination],
      prevButton2, nextButton2, pagination2, prevButton3, nextButton3, pagination3, prevButton4, nextButton4,
      pagination4, prevButton5, nextButton5, pagination5, prevButton6, nextButton6, pagination6, prevButton7,
      nextButton7, pagination7, prevButton8, nextButton8, pagination8, prevButton10, nextButton10, pagination10,
      secondScreen, scrollToSecondScreen, Tr
    };
  },
  watch:{
    '$i18n.locale'(newLocale, oldLocale) {
      this.showButton === this.$t("CharlaCompare.expandButton") ? this.showButton = this.$t("CharlaCompare.collapseButton") : this.showButton = this.$t("CharlaCompare.expandButton")
    },
  },
  computed: {
    ...mapGetters(['getCurrentPos', 'getCurrentMenuState','getFaqState']),
    SliderItems(){
      if (this.activeItem === 'Business Areas'){
        return [
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem1.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem1.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem2.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem2.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem3.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem3.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem4.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem5.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem5.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem5.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem6.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem6.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem7.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem7.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem8.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem8.text")
          },
        ]
      }else{
        return [
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem9.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem9.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem10.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem10.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem11.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem11.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem12.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem12.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem13.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem13.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem14.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem14.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem15.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem15.text")
          },
          {
            itemTitle: this.$t("charlaMoney.slider.carouselItem16.title"),
            itemText: this.$t("charlaMoney.slider.carouselItem16.text")
          },
        ]
      }
    },
    itemsComp(){
      if (this.audioMode === 'operator'){
        return [
          {response: [this.$t("CharlaCompare.slider.charlaResponse.phoneTalk.part1"), this.$t("CharlaCompare.slider.charlaResponse.phoneTalk.part2")]},
          {response: [this.$t("CharlaCompare.slider.appResponse.phoneTalk.part1"), this.$t("CharlaCompare.slider.appResponse.phoneTalk.part2")]},
          {response: [this.$t("CharlaCompare.slider.messengerResponse.phoneTalk.part1"), this.$t("CharlaCompare.slider.messengerResponse.phoneTalk.part2")]},
          {response: [this.$t("CharlaCompare.slider.searchResponse.phoneTalk.part1"), this.$t("CharlaCompare.slider.searchResponse.phoneTalk.part2")]},
        ]
      }else{
        return [
          {response: [this.$t("CharlaCompare.slider.charlaResponse.literary.part1"), this.$t("CharlaCompare.slider.charlaResponse.literary.part2")]},
          {response: [this.$t("CharlaCompare.slider.appResponse.literary.part1"), this.$t("CharlaCompare.slider.appResponse.literary.part2")]},
          {response: [this.$t("CharlaCompare.slider.messengerResponse.literary.part1"), this.$t("CharlaCompare.slider.messengerResponse.literary.part2")]},
          {response: [this.$t("CharlaCompare.slider.searchResponse.literary.part1"), this.$t("CharlaCompare.slider.searchResponse.literary.part2")]},
        ]
      }
    },
    audioSrc(){
      if (Tr.currentLocale === 'en'){
        if (this.audioMode === 'operator'){
          return '/audio/operator_en.mp3';
        }else{
          return '/audio/literary_en.mp3';
        }
      }
      else if (Tr.currentLocale === 'ru'){
        if (this.audioMode === 'operator'){
          return '/audio/operator_ru.mp3';
        }else{
          return '/audio/literary_ru.mp3';
        }
      }
      return '/audio/operator_en.mp3'
    }
  },
  methods: {
    ...mapActions(['getNewPosition', 'getNewMenuState', 'setLangState', 'setPrivacyState', 'setTermsState', 'setAboutState', 'setFormState', 'setWorkingPopup', 'setFaqState', 'setFaqContent']),
    stopAudio() {
      this.$refs.audioWaveMobile.resetAudio();
    },
    openAllCards(){
      this.showButton === this.$t("CharlaCompare.expandButton") ? this.showButton = this.$t("CharlaCompare.collapseButton") : this.showButton = this.$t("CharlaCompare.expandButton")
      const cardWrapper = [...document.querySelectorAll('.comment')];
      const cardContainer = [...document.querySelectorAll('.comment-text-wrapper')];
      cardWrapper.forEach((e,i) => {
        cardContainer[i].classList.toggle('comment-text-wrapper_opened')
        e.classList.toggle('comment_active')
      })
    },
    selectItems(item) {
      this.activeItem = item;
      if (item === 'Business Areas') {
        this.longSlides = false
        document.querySelector('#screen4').classList.remove('long-slides');
        document.querySelector('#screen4').classList.add('short-slides');

      } else if (item === 'Objectives') {
        this.longSlides = true
        document.querySelector('#screen4').classList.remove('short-slides')
        document.querySelector('#screen4').classList.add('long-slides');
      }
    },
    handleScroll() {
      const currentScrollPosition = window.scrollY;

      this.isScrollDown = currentScrollPosition > this.previousScrollPosition;

      setTimeout(() => {
        this.previousScrollPosition = currentScrollPosition;
      }, 50);
      //progress bar
      const scroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (scroll / height) * 100;
      document.querySelector('#progress').style.width = scrolled + '%';
    },
    onPhoneTalkClick() {
      this.activeButton = 'phoneTalk';
      this.stopAudio();
      this.audioMode = 'operator';
    },
    onLiteraryClick() {
      this.activeButton = 'literary';
      this.stopAudio();
      this.audioMode = 'literary';
    },

  },
  mounted() {
    this.showButton = this.$t("CharlaCompare.expandButton")
    this.getNewMenuState();
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style lang="sass" scoped>
@import "@/components/mobile/mobile/css/swiper-bundle.min.css"
@import "@/components/mobile/mobile/css/normalize.css"
@media screen and (max-width: 660px)
  a
    color: inherit
    text-decoration: none
  html, body
    scroll-behavior: smooth
  .mobile
    position: relative
    overflow-x: hidden
  h1, h2, h3, p
    margin: 0

  //Mobile
  .desktop
    display: none
  .mobile
    display: block
  .mobile-header
    position: fixed
    top: 0
    left: 0
    width: 100vw
    height: 68px
    box-sizing: border-box
    display: flex
    justify-content: space-between
    align-items: center
    padding: 18px 16px
    border-bottom: 2px solid #000
    background: #fff
    z-index: 100
    transform: translate3d(0, 0, 0)
    transition: .1s ease-in-out

  .mobile-header.hidden
    transform: translate3d(0, -100%, 0)
  .logo
    display: flex
    align-items: center
    gap: 12px
    font-weight: 600
    font-size: 22px
  .header-buttons
    display: flex
    align-items: center
    gap: 16px
  .login-btn
    position: static
  .menu-btn
    background: #000
    width: 36px
    height: 36px
    border-radius: 24px
    margin: 0
  .progress-bar-wrapper
    position: relative
  .progress-bar
    position: fixed
    box-sizing: border-box
    top: 0
    right: 0
    width: 90%
    height: 4px
    background: #ECE9F0
    z-index: 102
  .bg
    position: fixed
    top: 0
    left: 0
    background: #000
    width: 100%
    height: 4px
    z-index: 101
  #progress
    background: #000
    width: 0
    height: 100%
  h1
    font-weight: 400
    line-height: 118%
    font-size: 34px

    span
      display: flex
      align-items: center
      gap: 5px

    img
      max-width: 56px
  .h2
    font-weight: 400
    font-size: 28px
    line-height: 129%

    img
      margin-top: 16px
  h3
    font-weight: 600
    font-size: 16px
    line-height: 137%
    margin: 16px 0 32px 0

  #screen1
    display: flex
    flex-direction: column
    width: 100vw
    //height: 100vh

    h3
      margin: 16px 0

    h1
      padding-top: 90px

    .content-side
      position: relative
      width: 328px
      height: 330px
      margin: 32px auto 16px auto
  .title-side
    max-width: 296px
    width: 100%
    margin: auto
  .screen-start-btn
    display: flex
    align-items: center
    justify-content: center
    gap: 8px
  .btn-text
    max-width: 248px
    width: 100%
    height: 40px
    border-radius: 24px
    display: flex
    align-items: center
    justify-content: center
    background: #000
    color: #fff
    font-size: 13px
  .plus
    display: flex
    align-items: center
    justify-content: center
    width: 40px
    height: 40px
    border: 1px solid #000
    border-radius: 50%
    flex: none
  p
    font-size: 13px
    font-weight: 400
    line-height: 154%
    margin-top: 16px

  .video-mobile-wrapper
    position: absolute
    top: 0
    left: 0
    max-width: 328px
    max-height: 330px
    width: 100%
    height: 100%
    overflow: hidden
    border-radius: 20px
    z-index: -1

    video
      position: absolute
      top: 50%
      left: 50%
      min-width: 100%
      min-height: 100%
      width: 60%
      height: auto
      transform: translate(-50%, -50%)
  .next-btn
    display: flex
    align-items: center
    justify-content: center
    gap: 16px
    max-width: 328px
    width: 100%
    height: 40px
    border: 1px solid #000
    margin: auto
    border-radius: 20px
  #screen1 .content-side
    //display: flex
    //align-items: center
    //justify-content: center
    //flex-direction: column

  .screen1-slider
    height: 200px
    margin-top: 65px
    .swiper-slide:nth-child(1) .screen1-slide
      background: #B561F6

    .swiper-slide:nth-child(2) .screen1-slide
      background: #98DA2C

    .swiper-slide:nth-child(3) .screen1-slide
      background: #FF6332

    .swiper-slide:nth-child(4) .screen1-slide
      background: #B561F6
  .screen1-slide
    display: flex
    flex-direction: column
    justify-content: space-between
    height: 200px
    width: 160px
    border-radius: 20px
    padding: 16px
    box-sizing: border-box

    .number
      font-weight: 700
      font-size: 32px
      color: #fff

    .title
      font-weight: 600
      font-size: 16px
      line-height: 137%

    .text
      font-weight: 400
      font-size: 11px
      line-height: 164%
      color: #fff

    &:nth-child(1) .screen1-slide
      background: #B561F6

    &:nth-child(2) .screen1-slide
      background: #98DA2C

    &:nth-child(3) .screen1-slide
      background: #FF6332

    &:nth-child(4) .screen1-slide
      background: #B561F6

  //.screen
  //  padding-top: 32px
  //  &:first-child
  //    padding-top: 0
  #screen2
    padding-top: 32px

    h3

      gap: 5px
      margin: 16px 0

      span
        color: #98DA2C

    .content-side
      position: relative
      margin: 32px auto 16px auto
  .screen2-slider
    transform: translateX(-25px)


    .swiper-slide
      background: #fff
      border-radius: 20px
      padding: 8px
      box-sizing: border-box
      margin: auto

      img
        position: relative
        z-index: 10
        width: 100%
  .img-slide-wrapper
    position: relative
  .img-slide-title
    display: flex
    align-items: center
    justify-content: center
    text-align: center
    padding: 10px 0 35px 0
    font-size: 13px
    margin-bottom: -25px
    font-weight: 500
    background: #B561F6
    width: 100%
    border-radius: 20px 20px 0 0
    color: #fff
    box-sizing: border-box
  .slider-control
    display: flex
    align-items: center
    justify-content: space-between
    max-width: 296px
    width: 100%
    margin: 32px auto

  .join-btn
    display: flex
    align-items: center
    justify-content: center
    gap: 16px
    background: #000
    color: #fff
    max-width: 296px
    width: 100%
    height: 40px
    margin: auto
    border-radius: 24px
    font-size: 13px


  .swiper-button-next, .swiper-button-prev
    position: static
    width: auto
    height: auto
    margin: 0

    &:after
      display: none
  .swiper-button-disabled
    opacity: 1 !important

    svg path
      fill: #ECE9F0
  .divider
    height: 2px
    max-width: 296px
    width: 100%
    background: #000
    margin: 32px auto
  #screen3
    .tumb
      max-width: 50%
  .tumbs
    max-width: 320px
    width: 100%
    height: 40px
    padding: 4px
    box-sizing: border-box
    border: 1px solid #98DA2C
    border-radius: 24px
    display: flex
    align-items: center
    justify-content: space-between
    margin: 16px auto
  .tumb
    display: flex
    align-items: center
    justify-content: center
    max-width: 96px
    width: 100%
    height: 32px
    font-size: 10px
    font-weight: 400
    color: #000
    border-radius: 16px
    cursor: pointer
  .active-tumb
    background: #98DA2C

  .comment
    max-width: 296px
    width: 100%
    padding: 16px
    box-sizing: border-box
    margin: auto
    border-radius: 20px
    border: 1px solid #ECE9F0
    min-height: 320px
    display: grid
    grid-template-rows: auto
    transition: 300ms ease all
  .comment_active
    min-height: 400px
  .comment-header
    display: flex
    align-items: center
    justify-content: space-between
    text-align: center
    margin-bottom: 16px
  .comment-rating
    display: flex
    align-items: center
    gap: 2px
  .comment-text
    font-size: 11px
    font-weight: 400
    line-height: 164%
  .comment-button
    font-size: 11px
    font-weight: 400
    line-height: 164%
    width: 100%
    background-color: transparent
    border: none
    text-align: start
    align-self: flex-end
  .comment-text-wrapper
    display: grid
    grid-template-rows: 0fr
    transition: 300ms ease grid-template-rows
  .comment-text-wrapper_opened
    grid-template-rows: 1fr
  .comment-text-container
    overflow: hidden
  .comment-text-container .comment-text
    margin: 0
  .charla-result
    position: relative
    background: #98DA2C
    border: 1px solid #98DA2C
    border-radius: 20px 20px 20px 0
    margin-bottom: 20px
    display: grid
    grid-template-rows: auto

    .comment-header
      color: #fff
  .comment-clip
    position: absolute
    bottom: -24px
    left: -1px
  #screen4
    .tumbs
      border: 1px solid #B561F6

    .tumb
      max-width: 144px

    .active-tumb
      background: #B561F6
      color: #fff
  .long-slides
    #lastSlides
      display: none
    .card
      width: 100%
      height: 170px
  .slide-double-card
    display: flex
    flex-direction: column
    justify-content: center
    gap: 8px
  .card
    width: 100%
    height: 160px
    padding: 24px
    box-sizing: border-box
    border-radius: 20px
    border: 1px solid #000
    transition: .3s ease-in-out
  .card-header
    display: flex
    justify-content: space-between
  .card-title
    font-size: 16px
    font-weight: 600
    line-height: 137%
  .card-num
    font-weight: 400
    white-space: nowrap
    font-size: 11px
    line-height: 164%
  .card-text
    font-weight: 400
    font-size: 11px
    line-height: 164%
    margin-top: 16px
  .card--1
    background: #000 url("@/components/mobile/mobile/img/card1-bg.svg") no-repeat right bottom
    color: #fff
    border-color: #000
  .card--2
    background: #B561F6 url("@/components/mobile/mobile/img/card2-bg.svg") no-repeat right top
    color: #fff
    border-color: #B561F6
  .card--3
    background: #FF6332
    color: #fff
    border-color: #FF6332
  .card--4
    background: #fff url("@/components/mobile/mobile/img/card4-bg.svg") no-repeat right bottom
    color: #000
    border-color: #ECE9F0
  .card--5
    background: #fff url("@/components/mobile/mobile/img/card5-bg.svg") no-repeat right
    color: #000
    border-color: #ECE9F0
  .card--6
    background: #FF6332 url("@/components/mobile/mobile/img/card6-bg.svg") no-repeat left bottom
    color: #fff
    border-color: #FF6332
  .card--7
    background: #000 url("@/components/mobile/mobile/img/card7-bg.svg") no-repeat right
    color: #fff
    border-color: #000
  .card--8
    background: #B561F6
    color: #fff
    border-color: #B561F6
  #screen5
    h3 span
      color: #FF6332
  .slider5-slide
    display: flex
    flex-direction: column
    justify-content: space-between
    max-width: 240px
    height: 320px
    padding: 24px
    border-radius: 20px
    box-sizing: border-box

    .title
      font-weight: 600
      font-size: 16px
      line-height: 137%
      color: #000

    .num
      font-size: 32px
      font-weight: 700
      color: #fff
      margin: 16px 0 8px 0

    .text
      font-weight: 700
      font-size: 13px
      line-height: 154%
      color: #fff
  .vs-block
    display: flex
    justify-content: space-between
    align-items: center
    font-size: 11px
    font-weight: 400
    line-height: 164%

    .name
      color: #fff

    .desk
      color: #000
  .vs
    font-weight: 600
    font-size: 16px
    color: #fff
  .vs2
    text-align: right
  .text-slide5-block
    font-size: 11px
    font-weight: 400
    line-height: 164%
    color: #000

    span
      color: #fff
  .slide5--1
    background: #FF6332
  .slide5--2
    background: #B561F6
  .slide5--3
    background: #98DA2C

    .text-slide5-block
      color: #fff

      span
        color: #000
  .slide5--4
    background: #B561F6

    .name
      color: #fff

    .vs-block
      align-items: flex-start
      text-align: center
  #screen6
    h3
      display: flex
      align-items: center
      gap: 5px
  .screen6-slide
    display: flex
    flex-direction: column
    justify-content: space-between
    max-width: 240px
    height: 320px
    width: 100%
    padding: 24px
    border-radius: 20px
    box-sizing: border-box

    .slide-header
      font-weight: 600
      font-size: 20px
      color: #fff
      margin-bottom: 16px

      span
        color: #000

    .slide-body
      font-size: 11px
      font-weight: 400
      line-height: 164%
      color: #fff

    .slide-footer
      font-size: 11px
      font-weight: 400
      color: #000
      margin-top: 16px

    .btn
      display: flex
      align-items: center
      justify-content: center
      border-radius: 24px
      color: #fff
      font-weight: 700
      font-size: 13px
      height: 40px
      max-width: 192px
      background: #000
      margin: 16px auto auto auto
  .slide6--1
    background: #B561F6 url("@/components/mobile/mobile/img/A.svg") no-repeat top right
  .slide6--2
    background: #FF6332 url("@/components/mobile/mobile/img/B.svg") no-repeat top right
  .slide6--3
    background: #2cc5da url("@/components/mobile/mobile/img/C.svg") no-repeat top right
  .slide6--4
    background: #2CC5DA url("@/components/mobile/mobile/img/D.svg") no-repeat top right
  #screen7
  .slider7-slide
    position: relative
    display: flex
    flex-direction: column
    justify-content: space-between
    background: #F6F5F8
    border-radius: 0 20px 20px 20px
    padding: 24px
    box-sizing: border-box
    max-width: 240px
    width: 100%
    height: 350px
    box-shadow: inset 4px 0 0 0 #98DA2C

    .slider7-clip
      position: absolute
      top: 0
      left: -14px
      filter: drop-shadow(-4px 0 0 #98DA2C)

    .slide-header
      display: flex
      justify-content: space-between

    .name
      font-weight: 600
      font-size: 16px
      line-height: 137%

    .date
      font-size: 11px
      font-weight: 400

    .slide-body
      font-weight: 400
      font-size: 13px
      line-height: 154%

  .slide7-link
    background: #98DA2C

    .slide-header
      justify-content: flex-end

    .slide-footer
      font-weight: 600
      font-size: 16px
      line-height: 137%

    .slider7-clip
      position: absolute
      top: 0
      left: -20px
      filter: none
  .features
    display: flex
    justify-content: space-between
    margin-top: 16px
    margin-bottom: 32px

    div
      &:nth-child(1) .num
        color: #B561F6

      &:nth-child(2) .num
        color: #98DA2C

    .num
      font-weight: 700
      font-size: 32px
      margin-bottom: 8px

    .text
      font-weight: 400
      font-size: 11px
      line-height: 164%
  #screen8
    h3 span
      color: #FF6332
  .slider8-slide
    max-width: 240px
    width: 100%
    height: 320px
    padding: 24px
    box-sizing: border-box
    border-radius: 24px
    color: #fff

    .slide-header
      display: flex
      align-items: center
      justify-content: space-between
      margin-bottom: 16px

    .title
      font-weight: 600
      font-size: 16px

    .num
      font-weight: 400
      font-size: 11px

    .slide-body
      font-size: 13px
      font-weight: 400
      line-height: 154%

    .btn
      display: flex
      align-items: center
      justify-content: center
      gap: 16px
      max-width: 192px
      width: 100%
      height: 40px
      border-radius: 24px
      background: #FF6332
      color: #fff
      font-weight: 700
      font-size: 13px
  .slide8--1
    display: flex
    flex-direction: column
    justify-content: space-between
    background: #000 url("@/components/mobile/mobile/img/slider8-bg1.svg") no-repeat right bottom
  .slide8--2
    background: #B561F6 url("@/components/mobile/mobile/img/slider8-bg2.svg") no-repeat left bottom
  .slide8--3
    background: #FF6332 url("@/components/mobile/mobile/img/slider8-bg3.svg") no-repeat right bottom
  .slide8--4
    background: #000 url("@/components/mobile/mobile/img/slider8-bg4.svg") no-repeat center
  .slide8--5
    background: #FF6332 url("@/components/mobile/mobile/img/slider8-bg5.svg") no-repeat left top

  #screen9
    .content-side
      display: flex
      flex-direction: column
      gap: 8px
  .rate-block
    max-width: 298px
    width: 100%
    margin: auto
    border-radius: 20px
    padding: 24px
    box-sizing: border-box
    color: #fff

    &:nth-child(1)
      margin-top: 32px
      background: #000

      .start-btn
        background: #B561F6

    &:nth-child(2)
      background: #B561F6

      .rate-block-ul li:before
        background: url("@/components/mobile/mobile/img/li2.svg") no-repeat center/contain

      .special
        color: #000

    &:nth-child(3)
      background: #ECE9F0
      color: #000
  .rate-block-header
    display: flex
    align-items: center
    justify-content: space-between

    .name
      font-weight: 600
      font-size: 16px

    .price
      display: flex
      align-items: center
      font-weight: 400
      font-size: 13px

      span
        color: #B561F6
        font-weight: 600
        font-size: 16px
        margin-right: 3px
  .special
    margin: 10px 0 16px 0
    font-size: 13px
    font-weight: 700
    color: #B561F6
  .rate-block-ul
    ul
      display: flex
      flex-direction: column
      gap: 8px
      padding: 0

    li
      display: flex
      align-items: center
      gap: 8px
      list-style-type: none
      font-size: 11px
      font-weight: 400
      line-height: 164%

      p
        margin: 0
        font-size: 8px
        color: white
        background-color: #FF6332
        border-radius: 24px
        padding: 4px 8px



      &:before
        content: ''
        background: url("@/components/mobile/mobile/img/li1.svg") no-repeat center/contain
        width: 20px
        height: 18px
        flex: none
  .start-btn
    display: flex
    justify-content: center
    align-items: center
    gap: 16px
    color: #fff
    border-radius: 24px
    height: 40px
    max-width: 248px
    width: 100%
    margin: auto
    font-weight: 700
    font-size: 13px
    background: #000
  #screen10
  .slider10-slide
    display: flex
    flex-direction: column
    gap: 8px
    margin-top: 32px

  .slider10-card
    max-width: 240px
    width: 100%
    height: 160px
    padding: 24px
    display: flex
    justify-content: space-between
    border-left: 4px solid #B561F6
    border-radius: 20px
    background: #F6F5F8
    box-sizing: border-box

    .title
      max-width: 148px
      width: 100%
      font-size: 13px
      font-weight: 700
      line-height: 154%
      color: #000

    svg
      flex: none

  .heightCard
    justify-content: center
    .slider10-card
      height: 320px

  .slider10-link
    flex-direction: column
    justify-content: space-between
    background: #B561F6

    .title
      color: #fff

    svg
      margin-left: auto
  //footer
  footer
    max-width: 296px
    width: 100%
    margin: auto
    padding-bottom: 32px
  .footer-links
    display: flex
    flex-direction: column
    gap: 16px

    a
      display: flex
      align-items: center
      gap: 8px
      font-size: 11px
      font-weight: 400
  .footer-social-buttons
    display: flex
    align-items: center
    gap: 8px
    margin: 32px 0

    a
      display: flex
      align-items: center
      justify-content: center
      width: 40px
      height: 40px
      border-radius: 50%
      background: #000
  .copyright
    font-size: 11px
    font-weight: 400



</style>